import dayjs from 'dayjs';

export default function ({ remainingTerm, fromDate }) {
  const now = fromDate || new Date();
  return new Date(dayjs(now).add(remainingTerm, 'month'));
}
